import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { AreaChart, Area, XAxis, CartesianGrid, Tooltip, ResponsiveContainer, YAxis } from "recharts";

const chartStyles = {
  width: "100%",
  padding: "10px",
  color: "gray",
  ".title": { marginBottom: "20px" },
  ".chartGrid": { stroke: "rgb(228, 225, 225)" },
  "& .areachartBox": {
    boxShadow: "0px 2px 4px 0px #45C0CB",
    position: "relative",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: "url('/path/to/your/image.png')",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      opacity: 1,
      zIndex: 1,
      backgroundColor: "red",
      width: "100px",
      height: "20px",
    },
  },
};

function Chart({ rankingData, graphType }) {
  const [chartData, setChartData] = useState(null);
  useEffect(() => {
    if (!rankingData?.isoDates || !rankingData?.rows) return;

    const formattedData = rankingData?.averageGraphData?.map(item => {
      const date = new Date(item.date);
      const formattedDate = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
      });

      return {
        name: formattedDate,
        pv: item[graphType],
      };
    });

    setChartData(formattedData);
  }, [rankingData]);

  return (
    <Box sx={chartStyles}>
      <ResponsiveContainer height={180}>
        <AreaChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="gradientBackground" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="rgba(69, 192, 203, 0.2)" />
              <stop offset="100%" stopColor="rgba(69, 192, 203, 0)" />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" stroke="gray" />
          <YAxis domain={[0, 20]} dataKey="pv" />
          <CartesianGrid strokeDasharray="3 3" className="chartGrid" />
          <Tooltip />
          <Area type="monotone" className="areachartBox" dataKey="pv" stroke="#45C0CB" strokeWidth={2} fillOpacity={1} fill="url(#gradientBackground)" />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
}

export default Chart;
